// Toolbar item registry - maps string keys to components
import { BoldButton } from './BoldButton';
import { ItalicButton } from './ItalicButton';
import { UnderlineButton } from './UnderlineButton';
import { BulletListButton } from './BulletListButton';
import { OrderedListButton } from './OrderedListButton';
import { LinkButton } from './LinkButton';
import { HeadingSelector } from './HeadingSelector';
import { FontSizeSelector } from './FontSizeSelector';
import { Separator } from './Separator';
import { TextColorButton } from './TextColorButton';

export type ToolbarItemType =
  | 'HeadingSelector'
  | 'FontSizeSelector'
  | 'Bold'
  | 'Italic'
  | 'Underline'
  | 'BulletList'
  | 'OrderedList'
  | 'Link'
  | 'TextColor'
  | 'Separator';

export const TOOLBAR_ITEMS_REGISTRY: Record<ToolbarItemType, React.ComponentType> = {
  HeadingSelector: HeadingSelector,
  FontSizeSelector: FontSizeSelector,
  Bold: BoldButton,
  Italic: ItalicButton,
  Underline: UnderlineButton,
  BulletList: BulletListButton,
  OrderedList: OrderedListButton,
  Link: LinkButton,
  TextColor: TextColorButton,
  Separator: Separator,
};

// Default toolbar configuration
export const DEFAULT_TOOLBAR_ITEMS: ToolbarItemType[] = [
  'FontSizeSelector',
  'Separator',
  'Bold',
  'BulletList',
  'Link',
];
